module.exports = __webpack_public_path__ + "img/img-ilustrasi-ahli-gizi.891b4ffe.svg";